


























import {Component, Vue} from "vue-property-decorator";
import { events } from "./events";
import Teleport from "../Teleport/index.vue";
import CheckIcon from "../../assets/ics_f_check_circle.vue";
import { ToastParams } from ".";
import plugin from "./index"
import CssGroup from "./CssGroup.vue";
import VelocityGroup from "./VelocityGroup.vue";

enum STATE {
  IDLE = 0,
  DESTROYED = 2
}

type VelocityAnimationType = {
  enter: (el: Element) => void
  leave: {
    height: number
    opacity: number[]
  }
}

const velocityAnimation: VelocityAnimationType = {
  enter: (el: Element) => {
    var height = el.clientHeight

    return {
      height: [height, 0],
        opacity: [1, 0]
    }
  },
  leave: {
    height: 0,
    opacity: [0, 1]
  }
}

const Id = (i => () => i++)(0)

@Component({
  components: {
    Teleport,
    CheckIcon,
    CssGroup,
    VelocityGroup
  }
})
export default class Toast extends Vue {
  list: ToastParams[] = [];
  velocity = plugin.params?.velocity || ""
  speed = 300;

  created(): void {
    events.$on("add", this.addItem)
  }
  
  get active(): ToastParams[] {
    return this.list.filter(l => l.state !== STATE.DESTROYED)
  }
  
  addItem(event: ToastParams): void {
    event.group = event.group || ""
    
    if (event.clean || event.clear) {
      this.destroyAll()
    }
    
    const duration = event.duration || 3000
    const speed = event.speed || this.speed
    
    let {title, text, type, data, id} = event
    
    const item: ToastParams = {
      id: id || Id(),
      title,
      text,
      type,
      data,
      state: STATE.IDLE,
      speed,
      length: duration + 2 * speed,
    }
    
    if (duration > 0) {
      item.timer = setTimeout(() => {
        this.destroy(item)
      }, item.length)
    }
    
    let indexToDestroy = -1;
    
    const isDuplicate = this.active.some(item => {
      return item.title === event.title && event.text === item.text
    })
    
    this.list.unshift(item)
  }

  destroy(item: ToastParams): void {
    clearTimeout(item.timer)
    item.state = STATE.DESTROYED
  }

  destroyAll(): void {
    this.active.forEach(this.destroy)
  }
  destroyById (id: number): void {
    const item = this.list.find(v => v.id === id)

    if (item) {
      this.destroy(item)
    }
  }

  getAnimation (index: keyof VelocityAnimationType, el: Element): void | any {
    const animation = velocityAnimation[index]

    return typeof animation === 'function'
      ? animation.call(this, el)
      : animation
  }
  
  enter(event: any): void {
    let animation = this.getAnimation('enter', event.el)

    this.velocity(event.el, animation, {
      duration: this.speed,
      complete: event.complete
    })
  }
  
  leave(event: any): void {
    let animation = this.getAnimation('leave', event.el)

    this.velocity(event.el, animation, {
      duration: this.speed,
      complete: event.complete
    })
  }

  clean(): void {
    this.list = this.list.filter(v => v.state !== STATE.DESTROYED)
  }
}
